export const EB_WRITING_ASSISTANT_CARD_ALT_TEXT =
  'Writing suggestions from EasyBib Writing Assistant'
export const EB_CREATE_CITATION_CARD_ALT_TEXT = 'Generate citations with EasyBib'
export const EB_PLAGIARISM_CARD_ALT_TEXT = 'Checking for plagiarism with EasyBib'

export const CM_WRITING_ASSISTANT_CARD_ALT_TEXT =
  'Writing suggestions from Citation Machine Writing Assistant'
export const CM_CREATE_CITATION_CARD_ALT_TEXT = 'Generate citations with Citation Machine'
export const CM_PLAGIARISM_CARD_ALT_TEXT = 'Checking for plagiarism with Citation Machine'
